module.exports = __webpack_public_path__ + "img/logo.198de321.png";